import * as React from 'react';
import ReactTable from 'react-table';

import * as userService from '../../../services/user.service';
import { InvitedUser } from '../../../interface/user.interface';
import NotifyHOC from '../../../HOC/Notifications';
import Pagination from '../../common/pagination';
import Loader from '../../common/Loader/Loader';
import {
    parseAlertMessage,
    alertMessage
} from '../../../constants/alertMessage';
import { getUserDetails } from '@nexxt/common/firebase/auth/userDetails';

interface IInvitedUserProps {
    toastNotification: any;
}

interface IInvitedUserState {
    invitedUsers: InvitedUser[];
    isRequesting: boolean;
    filter: IFilter;
}
interface IFilter {
    email: string;
}

class InvitedUserPage extends React.Component<
    IInvitedUserProps,
    IInvitedUserState
> {
    private users: any = [];
    constructor(props) {
        super(props);
        this.state = {
            invitedUsers: [],
            isRequesting: false,
            filter: {
                email: ''
            }
        };
    }

    componentDidMount() {
        this.getInvitedUsers();
    }

    getInvitedUsers = async () => {
        this.setState({
            isRequesting: true
        });
        try {
            const invitedUsers = await userService.fetchInvitedUsers();
            this.setState({
                invitedUsers,
                isRequesting: false
            });
            this.users = invitedUsers;
        } catch (error) {
            this.setState({
                isRequesting: false
            });

            this.props.toastNotification.error(
                parseAlertMessage(
                    alertMessage.UNATHORIZED_ACCESS,
                    'Project manager'
                )
            );
        }
    };
    async sendRemiderEmail(userId: number) {
        const userDetails = getUserDetails();
        const checker = await userService.sendReminderOfInvitation(
            userId,
            userDetails.firstName
        );

        if (checker) {
            this.props.toastNotification.success(
                alertMessage.SUCCESS_SEND_REMINDER
            );
        } else {
            this.props.toastNotification.error(alertMessage.FAIL_SEND_REMINDER);
        }
    }
    buildColumns() {
        return [
            {
                Header: 'Email',
                accessor: 'email', // Note: Example of direct accessing data from accessor
                resizable: true,
                sortable: true
            },
            {
                Header: 'First Name',
                accessor: 'firstName',
                resizable: true,
                sortable: true,
                Cell: (props) => <span>{props.value}</span>
            },
            {
                Header: 'Last Name',
                accessor: 'lastName',
                resizable: true,
                sortable: true,
                Cell: (props) => <span>{props.value}</span>
            },
            {
                Header: 'Company',
                accessor: 'company',
                resizable: true,
                sortable: true,
                Cell: (props) => <span>{props.value}</span>
            },
            {
                Header: 'Job Title',
                accessor: 'jobTitle',
                resizable: true,
                sortable: true,
                Cell: (props) => <span>{props.value}</span>
            },
            {
                Header: 'Invited date',
                accessor: 'createdDate',
                resizable: false,
                minWidth: 200,
                sortable: false,
                headerClassName: 'no-sort',
                Cell: (props) => <span>{props.value.split('T')[0]}</span>
            },
            {
                Header: 'Re-send',
                accessor: '',
                resizable: false,
                minWidth: 200,
                sortable: false,
                headerClassName: 'no-sort',
                Cell: (props) => (
                    <button
                        onClick={async () =>
                            await this.sendRemiderEmail(props.value.id)
                        }
                    >
                        Send reminder
                    </button>
                )
            }
        ];
    }

    onSearch = (event) => {
        const { name, value } = event.target;
        this.setState({
            filter: {
                ...this.state.filter,
                [name]: value
            }
        });
    };

    render() {
        const { isRequesting, invitedUsers } = this.state;

        return (
            <div className="tabs-content off-white">
                <div className="filters">
                    {/* @TODO: improve search and re-enable
                    <div className="filters--search">
                        <input
                            type="text"
                            name="email"
                            placeholder="Search invited users by email"
                            onChange={this.onSearch}
                        />
                        <i className="nx nx-search" />
                    </div> */}
                </div>
                {!isRequesting ? (
                    <ReactTable
                        data={invitedUsers}
                        columns={this.buildColumns()}
                        defaultSorted={[
                            {
                                id: 'email',
                                desc: false
                            }
                        ]}
                        loading={!!isRequesting}
                        defaultPageSize={15}
                        pageSizeOptions={[5, 10, 15, 20]}
                        PaginationComponent={Pagination}
                        // LoadingComponent={({ loading }) =>
                        // loading ? <Loader /> : null
                        // }
                        NoDataComponent={(props) => (
                            <div className="rt-noData">
                                No pending invitations.
                            </div>
                        )}
                    />
                ) : (
                    <Loader />
                )}
            </div>
        );
    }
}
export default NotifyHOC(InvitedUserPage);
